import {
  GET_CHECKOUT_INFO_FAILURE,
  GET_CHECKOUT_INFO_SUCCESS,
  GET_CHECKOUT_INFO_REQUESTED,
  FS_CHANGE_SELECTED_PRODUCT,
  FS_CHECKOUT_SUCCESS,
  FS_CHECKOUT_ABORTED
} from '../actionCreators/checkoutActions';
import { RESET_STATE } from '../actionCreators/generalActions';
import { TRACK_OPEN_UPGRADE_MODAL } from '../actionCreators/trackingActions';
import { PRODUCTS } from '../config/checkout';

const initialState = {
  checkoutInfoLoaded: false,
  checkoutInfoLoading: true,
  item: {},
  error: '',
  isDefaultPricing: false,
  selectedProduct: PRODUCTS[0].path,
  upgradeTrackingProperties: null
};

export default function checkoutReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CHECKOUT_INFO_REQUESTED: {
      return {
        ...state,
        checkoutInfoLoading: true,
        checkoutInfoLoaded: false,
        isDefaultPricing: false,
        item: {}
      };
    }

    case GET_CHECKOUT_INFO_FAILURE: {
      return {
        ...state,
        error: action.error,
        checkoutInfoLoading: false,
        checkoutInfoLoaded: true,
        isDefaultPricing: false,
        item: {}
      };
    }

    case GET_CHECKOUT_INFO_SUCCESS: {
      return {
        ...state,
        checkoutInfoLoaded: true,
        checkoutInfoLoading: false,
        item: action.payload.item,
        licenceType: action.licenceType,
        isDefaultPricing: action.isDefaultPricing
      };
    }

    case FS_CHANGE_SELECTED_PRODUCT: {
      return {
        ...state,
        selectedProduct: action.path
      };
    }

    case TRACK_OPEN_UPGRADE_MODAL: {
      return {
        ...state,
        upgradeTrackingProperties: {
          trigger: action.trigger,
          extraEventProps: action.extraEventProps
        }
      };
    }

    case FS_CHECKOUT_SUCCESS:
    case FS_CHECKOUT_ABORTED: {
      return {
        ...state,
        upgradeTrackingProperties: null
      };
    }

    case RESET_STATE: {
      return {
        ...initialState
      };
    }

    default:
      return state;
  }
}
